import type { PageHelp } from '../network-help.data';

export const L10N_tr_g1: Record<string, PageHelp> = {
  customers: {
    title: 'Müşteriler',
    tag: 'CRM dizini',
    tagline: 'Bir acentenin satış yaptığı yolcuların ve şirketlerin ana kaydı.',
    business: {
      lead: 'Müşteriler, acentenin fiilen satış yaptığı taraflardır — bireysel yolcular, kurumsal hesaplar ve onlarla birlikte seyahat eden refakatçiler. Müşteri başına tek ve temiz bir kayıt tutmak, platformun rezervasyonları önceden doldurmasını, bir segmenti farklı fiyatlandırmasını, bir sadakat kulübü işletmesini ve doğru tarafı faturalandırmasını sağlayan şeydir. Faturalandırılabilir bir müşteri, alt akışta muhasebe tarafı (طرف حساب) da olur.',
      points: [
        { title: 'Tek gerçek kaynağı', desc: 'Ad, belge, iletişim ve onay bilgileri müşteri kaydında yer alır — rezervasyon ekranları buradan okur, böylece bir yolcu bir kez girilir ve her yerde yeniden kullanılır.' },
        { title: 'Segmentler fiyatı yönlendirir', desc: 'Bir müşteri bir müşteri grubuna ait olabilir; Markup ve Kurallar’ın Retail katmanı o grubu farklı fiyatlandırabilir — VIP’ler için indirim, gelen geçen için ücret.' },
        { title: 'Onay kaydedilir', desc: 'Pazarlama tercihi ve veri işleme onayı müşteri başına saklanır, böylece iletişim uyumlu kalır.' },
      ],
    },
    software: {
      lead: 'Her müşterinin aranabilir bir listesi; onları yönetmek için ihtiyaç duyduğunuz iletişim, sadakat ve onay sütunlarıyla birlikte.',
      points: [
        { title: 'Bul ve filtrele', desc: 'Ada, telefona, e-postaya veya kimlik numarasına göre arayın; tam profil için bir satırı açın.' },
        { title: 'Profili düzenle', desc: 'Düzenleme çekmecesi kimlik, telefon/WhatsApp (ayrı ülke kodu + numara), uyruk, tercih edilen kanal ve dil, VIP kademesi ve iç notları toplar; onlarla seyahat eden refakatçileri ekleyin.' },
        { title: 'Bir bakışta sadakat', desc: 'Her profil müşterinin puan bakiyesini, kademesini ve geçmişini gösterir; manuel kazanma / harcama / düzeltme ile.' },
      ],
    },
    related: ['customer-groups', 'loyalty', 'markup', 'agencies'],
  },

  'customer-groups': {
    title: 'Müşteri Grupları',
    tag: 'Segmentasyon',
    tagline: 'Müşterileri segmentlere etiketleyin, böylece Retail fiyatlandırma katmanı onlara farklı davranabilsin.',
    business: {
      lead: 'Bir müşteri grubu, karşısında fiyatlandırma yapabileceğiniz adlandırılmış bir segmenttir — “VIP’ler”, “Kurumsal — Acme”, “Gelen geçenler”. Bu, bir acente grubunun müşteri tarafındaki karşılığıdır: acente grupları Wholesale/Distribution kurallarını kapsarken, müşteri grupları Retail katmanını kapsar, böylece satış yapan acente kendi müşterilerinin bir dilimini ödüllendirebilir veya ek ücretlendirebilir.',
      points: [
        { title: 'Perakende marjı için bir kaldıraç', desc: 'Grup üyeliği, bir Retail kuralının hedeflediği şeydir — örneğin VIP grubu için −%3 sadakat indirimi ya da doğrulanmamış gelen geçenler için hizmet ücreti.' },
        { title: 'Üyelik, hiyerarşi değil', desc: 'Bir müşteri yalnızca bir gruba aittir; iç içe geçme yoktur. Tek net bir etiket fiyatlandırmayı öngörülebilir tutar.' },
        { title: 'Acenteye ait', desc: 'Her acente kendi müşterileri üzerinde kendi gruplarını tanımlar — bunlar ağ genelinde sızmaz.' },
      ],
    },
    software: {
      lead: 'Gruplar oluşturun ve müşteriler atayın, ardından grubu bir Retail fiyatlandırma kuralının Grup kapsamından referans verin.',
      points: [
        { title: 'Bir grup oluştur ve adlandır', desc: 'Bir grubu kod ve adla tanımlayın; segmentler geliştikçe etkinleştirin veya arşivleyin.' },
        { title: 'Üye ata', desc: 'Bir gruba müşteri ekleyin veya çıkarın; sayı grupta ve Markup ve Kurallar’ın Grup kapsamlı satırlarında görünür.' },
        { title: 'Fiyatlandırmaya bağla', desc: 'Markup ve Kurallar’da bir Retail kuralında partner kapsamı = Grup seçin ve bu grubu seçin — üyeleri için eşleşen her rezervasyon kuralı uygular.' },
      ],
    },
    examples: [
      {
        title: 'Retail katmanında bir VIP grup indirimi',
        rows: [
          { label: 'Yolcu ara toplamı (retail kuralından önce)', value: '11,024,000' },
          { label: 'Retail DISCOUNT −%3 · grup = VIP’ler', value: '−330,720', accent: 'success', strong: true },
          { label: 'VIP müşteri öder', value: '10,693,280' },
        ],
        note: 'VIP olmayan bir müşteri için aynı rezervasyon kuralı atlar ve 11,024,000 öder. Tek fark grup üyeliğidir.',
      },
      {
        title: 'Bir gelen geçen hizmet ücreti — diğer yön',
        rows: [
          { label: 'Yolcu ara toplamı', value: '11,024,000' },
          { label: 'Retail SERVICE_FEE +150,000 · grup = Gelen geçenler', value: '+150,000', accent: 'accent', strong: true },
          { label: 'Gelen geçen müşteri öder', value: '11,174,000' },
        ],
        note: 'Sabit bir SERVICE_FEE, doğrulanmamış bir segmente ek ücret uygular. Sabit kurallar ücret büyüklüğünü göz ardı eder — her gelen geçen rezervasyonu, bilet fiyatı ne olursa olsun aynı 150,000’i ekler.',
      },
      {
        title: 'Kurumsal net fiyat — bir grup pazarlıkla anlaşılmış bir teklifi de açabilir',
        rows: [
          { label: 'Standart yolcu ara toplamı', value: '11,024,000' },
          { label: 'Retail DISCOUNT −%6 · grup = Kurumsal · Acme', value: '−661,440', accent: 'success', strong: true },
          { label: 'Acme’nin çalışanı öder', value: '10,362,560' },
        ],
        note: 'Daha derin bir grup indirimi bir kurumsal sözleşmeyi kodlar: “Kurumsal · Acme” olarak etiketlenmiş herkes otomatik olarak Acme’nin pazarlıkla anlaştığı %6 indirimi alır — rezervasyon başına geçersiz kılma yok.',
      },
    ],
    related: ['customers', 'markup', 'agency-groups', 'loyalty'],
  },

  loyalty: {
    title: 'Sadakat Kulübü',
    tag: 'Voyager Rewards',
    tagline: 'Acentenin puan programı — yolcuların nasıl kazandığı, kademe çıktığı ve harcadığı.',
    business: {
      lead: 'Bir sadakat kulübü, tek seferlik yolcuları tekrar edenlere dönüştürür. Müşteriler rezervasyon yaptıkça puan kazanır, ayrıcalıklar ve daha iyi kazanma oranları açan kademelere çıkar ve puanları gelecekteki rezervasyonlara karşı harcar. Ödenmemiş bakiye, acentenin taşıdığı gerçek bir yükümlülüktür, bu yüzden kulüp açık kazanma ve harcama oranlarıyla işletilir.',
      points: [
        { title: 'Nicelendirilmiş bağlılık', desc: 'Puanlar ve kademeler, bir müşteriye bir rakip yerine yeniden sizinle rezervasyon yapması için bir neden verir.' },
        { title: 'Yaşam boyu kazanılana göre kademeler', desc: 'Bir müşterinin kademesi yaşam boyu kazanılan puanları yansıtır, bu yüzden harcamak asla kademe düşürmez — Bronz → Gümüş → Altın → Platin, her biri daha yüksek bir kazanma çarpanıyla.' },
        { title: 'Puanlar bir yükümlülüktür', desc: 'Harcanmamış her puan borçlanılan paradır; kulüp genel bakışı toplam puanları ve para birimi yükümlülüğünü yüzeye çıkarır, böylece defterlerde kalır.' },
      ],
    },
    software: {
      lead: 'Bir kulüp genel bakışı ile onu işleten iki şey: ayarlar (oranlar + tetikleyici) ve otomatik kazanma kuralları.',
      points: [
        { title: 'Genel bakış KPI’leri', desc: 'Üyeler, toplam puanlar, yükümlülük ve kademe başına dağılım — defterden canlı hesaplanır.' },
        { title: 'Kulüp ayarları', desc: 'Kazanma oranını, harcama oranını (birim başına puan), puan geçerlilik süresini ve otomatik kazanma tetikleyicisini ayarlayın — ISSUE’da (tamamlandığında) veya PAID’de (ödeme alındığında) ödüllendirin.' },
        { title: 'Kazanma kuralları', desc: 'Ürün başına puan kuralları yazın (örn. Uçuşlar birim başına 2× kazanır); bir rezervasyonun tamamlanması eşleşen kuraldan puanları otomatik ödüllendirir. Müşteri başına kazanma / harcama / düzeltme her profildedir.' },
      ],
    },
    modes: {
      lead: 'İki ayrı kademe kavramı vardır — onları karıştırmayın.',
      modes: [
        { name: 'Sadakat kademesi', when: 'kazanılan', desc: 'Bronz / Gümüş / Altın / Platin, yaşam boyu kazanılan puanlardan türetilir. Kazanma çarpanını ve ayrıcalıkları yönlendirir. Asla elle ayarlanmaz.' },
        { name: 'VIP kademesi', when: 'manuel', desc: 'Bir acentenin müşteri kaydında hizmet işlemesi için ayarladığı ayrı bir işaret (Standart / Gümüş / Altın / VIP) — sadakat puanlarından bağımsızdır.' },
      ],
    },
    examples: [
      {
        title: 'Kademe eşikleri — yaşam boyu kazanılan puanlarla belirlenir',
        rows: [
          { label: 'Bronz · 0+ kazanılan', value: '1× kazanma' },
          { label: 'Gümüş · 2,000+ kazanılan', value: '1.25× kazanma' },
          { label: 'Altın · 6,000+ kazanılan', value: '1.5× kazanma', accent: 'info' },
          { label: 'Platin · 15,000+ kazanılan', value: '2× kazanma', accent: 'success' },
        ],
        note: 'Kademe yaşam boyu kazanılanı okur, bu yüzden puan harcamak bir müşteriyi asla düşürmez.',
      },
      {
        title: 'Bir rezervasyonda otomatik kazanma ve bir kademe sıçraması',
        rows: [
          { label: 'Öncesinde yaşam boyu kazanılan (Gümüş)', value: '5,600' },
          { label: 'Uçuş kuralı · birim başına 2 puan × 250', value: '+500', accent: 'info', strong: true },
          { label: 'Sonrasında yaşam boyu kazanılan → Altın', value: '6,100' },
        ],
        note: 'Rezervasyon kulübün kazanma tetikleyicisine (ISSUE veya PAID) ulaştığında puanlar otomatik işlenir. 6,000’i geçmek müşteriyi Altın’a yükseltir — o andan itibaren 1.5× kazanma.',
      },
      {
        title: 'Puan harcama (varsayılan 100 puan = 1 birim indirim)',
        rows: [
          { label: 'Puan bakiyesi', value: '8,000' },
          { label: '5,000 puan harca → indirim', value: '−50', accent: 'success' },
          { label: 'Kalan bakiye', value: '3,000', strong: true },
        ],
        note: 'Harcama oranı Kulüp ayarlarında belirlenir; bakiye harcanabilir puandır, kademeyi belirleyen yaşam boyu kazanılandan farklıdır.',
      },
      {
        title: 'Kulüp yükümlülüğü — ödenmemiş puanların değeri nedir',
        rows: [
          { label: 'Üyeler genelinde toplam harcanmamış puan', value: '2,400,000' },
          { label: '÷ harcama oranı (100 puan = 1)', value: '÷ 100' },
          { label: 'Defterlerdeki para birimi yükümlülüğü', value: '24,000', accent: 'accent', strong: true },
        ],
        note: 'Genel bakış bunu yüzeye çıkarır, böylece kulüp asla gizli bir maliyet olmaz. Harcama oranını yükseltmek (birim başına daha çok puan) yükümlülüğü düşürür ama puanların müşteri için daha az değer kazanmasına yol açar — dengelenecek kaldıraç.',
      },
    ],
    related: ['customers', 'customer-groups', 'markup'],
  },

  agencies: {
    title: 'Acenteler',
    tag: 'Dizin',
    tagline: 'Platformda işlem yapan B2B seyahat işletmelerinin ana dizini.',
    business: {
      lead: 'Acenteler, platformun B2B müşterileridir — envanter sattığınız seyahat şirketleri. Her biri, nasıl işlem yaptığını yöneten ticari ve uyum koşullarını taşır: kademesi, cüzdanı veya kredi limiti ve KYC durumu.',
      points: [
        { title: 'Kademeler koşulları belirler', desc: 'Bir acentenin kademesi fiyatlandırmasının arkasındaki kaldıraçtır — Markup ve Kurallar motorundaki Kademe kapsamlı kuralları besler, böylece hacim daha iyi marjla ödüllendirilebilir.' },
        { title: 'Cüzdan ve kredi işlem limitidir', desc: 'Bir acente ön ödemeli bir cüzdana veya onaylı bir kredi limitine karşı rezervasyon yapar; o bakiye platformun maruz kalmasını sınırlar.' },
        { title: 'KYC işlemi sınırlar', desc: 'Yeni bir acente ancak KYC onaylandığında canlıya geçer — durum sütunu, satır başına, kimin işlem yaptığını ve kimin engellendiğini gösterir.' },
      ],
    },
    software: {
      lead: 'Her acentenin aranabilir bir listesi; onları bir bakışta yönetmek için ihtiyaç duyduğunuz ticari ve uyum sütunlarıyla birlikte.',
      points: [
        { title: 'Tara ve filtrele', desc: 'Ada, iletişime veya koda göre arayın ve kimin önemli olduğunu bulmak için kademeye veya duruma göre filtreleyin.' },
        { title: 'Sağlık sütunlarını oku', desc: 'Cüzdan bakiyesi, kredi kullanımı ve KYC durumu satır başına görünür.' },
        { title: 'Bir kaydı aç', desc: 'Acente profilini açmak için bir satıra tıklayın — koşullarını, SIGN’larını, satış kanallarını, rollerini ve erişimini düzenleyin.' },
      ],
    },
    related: ['agency-profile', 'agents', 'agency-onboarding', 'markup'],
  },

  markup: {
    title: 'Markup ve Kurallar',
    tag: 'Fiyatlandırma motoru',
    tagline: 'Her marj katmanının — SIGN sahibinden bayiye, yolcuya kadar — tanımlandığı yer.',
    business: {
      lead: 'Bir fiyatın, tedarikçinin net ücretinden yolcunun ödediği tutara kadar nasıl oluşturulduğudur bu. Motor katmanlıdır: bir Wholesale markup (SIGN sahibi bir bayiye ücret uygular), bir Distribution ücreti (bir kanal sahibi kendi kanalından satan acenteye ücret uygular) ve bir Retail marjı (satış yapan acentenin müşteriye kendi markup’ı). Her katman farklı bir tarafın parasıdır.',
      points: [
        { title: 'Üç katman, üç ilişki', desc: 'Wholesale = SIGN sahibi → bayi; Distribution = kanal sahibi → satıcı; Retail = satıcı → yolcu. Bir kural her zaman tam olarak bir katmana aittir.' },
        { title: 'Segmente göre hedefli', desc: 'Kurallar ürüne, tedarikçiye, havayoluna, güzergaha, kabine, SIGN’a veya kanala, partner kademesine veya grubuna ya da belirli bir partner acenteye göre daralır — böylece hassas fiyatlandırabilirsiniz.' },
        { title: 'Koruma bantları fiyatı korur', desc: 'Min / maks sınırlar, öncelik ve etkin / etkin değil durumu, kötü bir kuralın bir ücreti rekabetçi olmaktan veya kârlı olmaktan çıkarmasını engeller.' },
      ],
    },
    software: {
      lead: 'Özgüllüğe göre çözümlenen bir kural motoru — her katman içinde en özgül eşleşen kural kazanır.',
      points: [
        { title: 'Özgüllük sırası', desc: 'Partner → Kademe → SIGN / Kanal → Güzergah → Sahip varsayılanı. Çözümleyici bir rezervasyonun her katmanı için bu merdiveni izler.' },
        { title: 'Puanlama, çözümleyicinin nasıl seçtiğidir', desc: 'Bir kuralın ayarladığı her joker olmayan eşleşme boyutu, puanına sabit bir ağırlık katar. Katman başına kazanan = en yüksek puan. Beraberlik → daha yüksek `priority` kazanır; yine beraberlik → daha yakın zamanda güncellenmiş kural kazanır. Simülatör, bir kuralın diğerini neden yendiğini tam olarak görebilesiniz diye her aday kartında puanı gösterir.' },
        { title: 'Kuralları oluştur ve filtrele', desc: 'Bir kuralın katmanını, düzeltme türünü, değerini (yüzde / sabit / kademeli), temelini ve kapsamını yazın; büyüyen listeyi türe, ürüne, partner kapsamına veya duruma göre filtreleyin.' },
        { title: 'Canlı olmadan önce simüle et', desc: 'Yerleşik simülatör varsayımsal bir rezervasyonu fiyatlandırır ve katman başına tam olarak hangi kuralın devreye girdiğini gösterir — canlı fiyatlandırmaya risk olmadan.' },
      ],
    },
    examples: [
      {
        title: 'Özgüllük ağırlıkları — her eşleşme boyutunun değeri',
        rows: [
          { label: 'Partner = belirli ACENTE', value: '100' },
          { label: 'SIGN (wholesale) · Kanal (distribution)', value: '90' },
          { label: 'Kalkış ve Varış — havaalanı / istasyon', value: '70' },
          { label: 'Partner GRUBU', value: '60' },
          { label: 'Kalkış ve Varış — şehir', value: '50' },
          { label: 'Partner KADEMESİ', value: '40' },
          { label: 'Bölge', value: '35' },
          { label: 'Tedarikçi · Havayolu · Ücret türü', value: 'her biri 30' },
          { label: 'Kabin', value: '25' },
          { label: 'Ürün', value: '20' },
        ],
        note: 'Bir kuralın puanı, rezervasyonla fiilen eşleşen her joker olmayan boyutun ağırlıklarının toplamıdır. Jokerler (boş) puan getirmez — yalnızca dışlamazlar.',
      },
      {
        title: 'İki kural yarışır — en yüksek puan kazanır',
        rows: [
          { label: 'Rezervasyon: satıcı = Nomad (GOLD kademesi), ürün = uçuş', value: '' },
          { label: 'Kural A · WHOLESALE · TIER=GOLD + ürün=uçuş', value: '40 + 20 = 60', accent: 'info' },
          { label: 'Kural B · WHOLESALE · AGENCY=Nomad', value: '100', accent: 'success' },
          { label: 'Kazanan', value: 'Kural B', strong: true },
        ],
        note: 'Her iki kural da bu rezervasyonla eşleşir. Kural B’nin partner-acente kilidi tek başına 100 puan alır — Kural A’nın kademe+ürün kombinasyonunu (60) yener. Partnere özel, motorun bildiği en özgül boyuttur.',
      },
      {
        title: 'Aynı puan — öncelik beraberliği bozar',
        rows: [
          { label: 'Rezervasyon: ürün=uçuş, kabin=BUSINESS, tedarikçi=Amadeus', value: '' },
          { label: 'Kural X · ürün+kabin (20+25) · öncelik=0', value: 'puan 45 · öncelik 0' },
          { label: 'Kural Y · ürün+tedarikçi (20+30) · öncelik=10', value: 'puan 50 · öncelik 10', accent: 'success' },
          { label: 'Kazanan', value: 'Kural Y (daha yüksek puan)', strong: true },
        ],
        note: 'Y ham puanda kazanır (50 > 45). İki kural puanda beraber kalırsa `priority` bunu bozar — ve `priority` de beraberse daha yakın zamanda güncellenmiş kural kazanır. Bu son beraberlik bozucu, mevcut bir kuralı düzenlemenin onu, aksi halde beraber kalan bir grubun tepesine tazelediği anlamına gelir.',
      },
      {
        title: 'Wholesale — SIGN sahibi → bayi (net ücret üzerinden)',
        rows: [
          { label: 'Havayolu net', value: '10,000,000' },
          { label: 'MARKUP net’in +%4’ü', value: '+400,000', accent: 'info' },
          { label: 'Bayinin maliyeti', value: '10,400,000', strong: true },
        ],
      },
      {
        title: 'Retail — satıcı → yolcu (yürüyen brüt üzerinden)',
        rows: [
          { label: 'Yürüyen toplam', value: '10,400,000' },
          { label: 'MARKUP brüt’ün +%6’sı', value: '+624,000', accent: 'success' },
          { label: 'Yolcu ara toplamı', value: '11,024,000', strong: true },
        ],
      },
      {
        title: 'Distribution — kanal ücreti (ek ödeme vs gelir paylaşımı)',
        rows: [
          { label: 'Ek ödeme +%2, 11,024,000 üzerinde', value: '+220,480', accent: 'accent' },
          { label: 'Gelir paylaşımı %2 (marjdan)', value: 'price unchanged' },
        ],
        note: 'Ek ödeme ücretin üzerine eklenir; gelir paylaşımı yolcu fiyatını değiştirmez ve kanalın payını satıcının marjından düşer.',
      },
      {
        title: 'Değer modları — temel 10,000,000, 3 yolcu / 2 segmentlik rezervasyon',
        rows: [
          { label: 'Yüzde · %5 × 10,000,000', value: '500,000' },
          { label: 'Sabit · rezervasyon başına 150,000', value: '150,000' },
          { label: 'Sabit · yolcu başına 150,000 × 3', value: '450,000' },
          { label: 'Sabit · segment başına 150,000 × 2', value: '300,000' },
          { label: 'Yüzde + sabit · %3 + 200,000', value: '500,000' },
        ],
        note: 'Herhangi bir katman herhangi bir modu kullanabilir. Düzeltme türü işareti belirler: MARKUP / SERVICE_FEE ekler; DISCOUNT / REBATE çıkarır.',
      },
      {
        title: 'Uçtan uca şelale — partner bir SIGN altında bilet keser, sonra tekrar satar',
        rows: [
          { label: 'Tedarikçi net (havayolu)', value: '10,000,000' },
          { label: '+ Wholesale MARKUP %4', value: '+400,000', accent: 'info' },
          { label: '+ Retail MARKUP %6', value: '+624,000', accent: 'success' },
          { label: '+ Distribution ek ödemesi %2', value: '+220,480', accent: 'accent' },
          { label: 'Yolcu fiyatı', value: '11,244,480', strong: true },
        ],
        note: 'Tam olarak Simülatörün hesapladığı şey. Ek ödeme yerine gelir paylaşımı ile yolcu yine 11,024,000 öder ve kanalın 220,480’i satıcının marjından çıkar.',
      },
    ],
    related: ['agency-groups', 'sign-access', 'channel-access', 'agencies'],
  },

  'partner-access': {
    title: 'Partner Erişimi',
    tag: 'Eşleştirme',
    tagline: 'Acentelerin biletleme kimlik bilgilerini (SIGN’lar) ve satış kanallarını paylaşmak için nasıl eşleştiği.',
    business: {
      lead: 'Her acente, satabileceği her şeyi biletlemek için gereken havayolu kimlik bilgilerine (SIGN’lar) veya satış kanallarına sahip değildir. Partner Erişimi, iki acentenin bağlanıp bu varlıkları paylaşmasını sağlar — böylece biri diğerinin SIGN’ında bilet kesebilir veya kanalından satabilir — ikisi de yeni envanter satın almadan ne satabileceklerini genişletir.',
      points: [
        { title: 'Erişimi ödünç al, kontrolü koru', desc: 'Sahip erişim verir ve dilediği zaman geri alabilir — paylaşmak bir izindir, varlığın devri değil.' },
        { title: 'Her iki taraf da anlaşmalı', desc: 'Eşleştirme ve her erişim verme iki yönlü onaydır: herhangi bir varlık paylaşılmadan önce karşı tarafın kabul ettiği bir teklif veya istektir.' },
        { title: 'İki değer yönü', desc: 'Partnerlere dışa paylaştığınızı ve onlardan kullandığınızı iki ayrı defter olarak izlersiniz.' },
      ],
    },
    software: {
      lead: 'Bu ekran eşleştirmeleri ve bunlar arasında akan SIGN / Satış Kanalı erişimlerini yönetir.',
      points: [
        { title: 'Acente koduyla bağlan', desc: 'Bir partnerin benzersiz acente kodunu kullanarak bir partnerlik isteği gönderin; kabul veya reddederler.' },
        { title: 'SIGN ve Satış Kanalı ver', desc: 'Bir partnere bir SIGN (havayolu biletleme kimlik bilgisi) veya bir Satış Kanalı sunun; kapsamlı ve süreli olarak; alan taraf etkinleştirmek için kabul eder.' },
        { title: 'Her iki defteri de yönet', desc: 'Verdiğiniz erişimi ve aldığınız erişimi gözden geçirin ve bir ilişki bittiğinde geri alın.' },
      ],
    },
    examples: [
      {
        title: 'Bir SIGN paylaşırsınız — her partner biletinde wholesale markup kazanırsınız',
        rows: [
          { label: 'Partner bir EK bileti keser · havayolu net', value: '10,000,000' },
          { label: 'Sizin Wholesale markup %4 (size öderler)', value: '+400,000', accent: 'info', strong: true },
          { label: 'Partnerin bilet maliyeti', value: '10,400,000' },
        ],
        note: 'Rezervasyona hiç dokunmazsınız — SIGN’ınızı paylaşmak, partnerin onun altında kestiği her bilet için size 400,000 kazandırır. Kendi müşterileri için ekledikleri retail marjı ise kendilerinde kalır.',
      },
      {
        title: 'Bir partnerin SIGN’ını kullanırsınız — onların wholesale’ini ödeyin, kendi retail’inizi koruyun',
        rows: [
          { label: 'Onların SIGN’ında bir EK bileti keseresiniz · net', value: '10,000,000' },
          { label: '+ Onların Wholesale markup %4 → maliyetiniz', value: '10,400,000' },
          { label: '+ Müşterinize Retail markup %6’nız', value: '+624,000', accent: 'success' },
          { label: 'Müşteriniz öder', value: '11,024,000', strong: true },
        ],
        note: 'Bir SIGN ödünç almak, tutmadığınız bir havayolunu satmanızı sağlar. Sahibin wholesale markup’ını ödersiniz ve kendi 624,000 retail marjınızı korursunuz.',
      },
      {
        title: 'Bir Satış Kanalı paylaşırsınız — gelir paylaşımı vs ek ödeme',
        rows: [
          { label: 'Partner kanalınız üzerinden 10,000,000 ücret satar', value: '10,000,000' },
          { label: 'Gelir paylaşımı %2 (sizin payınız, onların marjından)', value: '+200,000', accent: 'accent', strong: true },
          { label: 'Ek ödeme %2 (üstüne eklenir → yolcu öder)', value: '10,200,000' },
        ],
        note: 'Gelir paylaşımı size satıcının marjından 200,000 kazandırır ve yolcu fiyatı değişmez; ek ödeme ücretinizi ücretin üstüne ekler. Hangisi olduğunu, erişim başına siz belirlersiniz.',
      },
    ],
    related: ['sign-access', 'channel-access', 'signs', 'sale-channels'],
  },

  agents: {
    title: 'Alt Acenteler',
    tag: 'Alt hat',
    tagline: 'Bir ana acentenin altında yer alan ve onun adına satış yapan bayiler.',
    business: {
      lead: 'Alt acenteler, platformun herkesi doğrudan katmasına gerek kalmadan dağıtımı genişletir. Bir ana acente onları toplar, ticari koşullarını belirler ve işlemlerinin arkasında durur — tek bir ilişkiyi bir satış zincirine dönüştürür.',
      points: [
        { title: 'Ek yük olmadan erişim', desc: 'Her alt acente, platformun tek tek sözleşmelemek veya fonlamak zorunda kalmadığı yeni bir satış noktasıdır.' },
        { title: 'Marj katmanlıdır', desc: 'Ana acente, alt acente bir ücret görmeden önce platformun fiyatının üzerine kendi Retail markup’ını ekleyebilir — bu fark onun işidir.' },
        { title: 'Birleştirilmiş hesap verebilirlik', desc: 'Cüzdan, kredi ve mutabakat üst acenteye toplanır, böylece platform tek bir karşı tarafla mutabakat yapar.' },
      ],
    },
    software: {
      lead: 'Bir acenteye bağlı raporlanan herkesi listeler; her birinin ne yapabileceğini yöneten kontrollerle birlikte.',
      points: [
        { title: 'Acente başına yapılandırma', desc: 'Markup geçersiz kılmaları, izin verilen ürünler ve erişim her alt acentede kendi kaydından ayarlanır.' },
        { title: 'Toplam roll-up’lar', desc: 'Alt hattan gelen rezervasyonlar ve gelir üst acenteye ve ağ toplamına toplanır.' },
        { title: 'Yönetici vs acente görünümü', desc: 'Yöneticiler tüm ağı görür; oturum açmış bir acente yalnızca kendi alt hattını görür.' },
      ],
    },
    related: ['agencies', 'markup', 'partner-access'],
  },

  companies: {
    title: 'Şirketler',
    tag: 'Kurumsal ana kuruluş',
    tagline: 'Satış kanallarına sahip olan ve acenteleri tek çatı altında gruplayan tüzel kişilikler.',
    business: {
      lead: 'Bir şirket, acentelerin üstündeki kurumsal ana kuruluştur — satış kanallarına sahip olabilen ve dolayısıyla Distribution katmanının ücretlerini kazanabilen kuruluş. Markaları veya acenteleri tek bir şirket altında gruplamak, paylaşılan ticari varlıkların ve mutabakatın sahipliğini tek bir yerde tutar.',
      points: [
        { title: 'Dağıtım varlıklarına sahiptir', desc: 'Şirketler satış kanallarına sahiptir (SIGN’lara değil); bir şirketin Distribution kuralları o kanallardan akanı fiyatlandırır.' },
        { title: 'Tek tüzel karşı taraf', desc: 'Birden fazla acente veya marka, sözleşme ve mutabakat için tek bir şirket altında yer alabilir.' },
        { title: 'Sorumlulukların ayrılığı', desc: 'Havayolu biletlemesi (SIGN’lar) acentelerde yaşar; kanal dağıtımı şirkette yaşar.' },
      ],
    },
    software: {
      lead: 'Şirketlerin ve sahip oldukları kanalların dizini.',
      points: [
        { title: 'Şirket kayıtlarını yönet', desc: 'Şirketler oluşturun ve düzenleyin ve her birine bağlı acenteleri ve kanalları görün.' },
        { title: 'Kanal sahipliği', desc: 'Bir şirketin satış kanalları Satış kanalları’ndan yönetilir ve Markup ve Kurallar’dan (Distribution katmanı) fiyatlandırılır.' },
        { title: 'Seçicilerde kapsam', desc: 'Şirket sahipleri Markup ve Kurallar sahip seçicisinde “yalnızca kanallar” olarak görünür.' },
      ],
    },
    related: ['sale-channels', 'channel-access', 'agencies'],
  },

  'sale-channels': {
    title: 'Satış kanalları',
    tag: 'Dağıtım',
    tagline: 'Envanterin satıldığı vitrinler ve borular.',
    business: {
      lead: 'Bir satış kanalı, pazara açılan bir yoldur — bir web sitesi, uygulama, API entegrasyonu veya çevrimdışı masa — bir acenteye veya şirkete ait. Distribution katmanının karşısında ücretlendirdiği varlıktır: kanala kim sahipse, ondan satılan üzerinden bir ücret veya gelir payı alabilir.',
      points: [
        { title: 'Bir kanal bir gelir noktasıdır', desc: 'Bir kanaldan akan satışlar, kanal sahibi için bir Distribution ücreti veya gelir payı taşıyabilir.' },
        { title: 'Sahip ol veya ödünç al', desc: 'Kendi kanallarınızdan ya da bir Kanal erişimi vermesi yoluyla bir partnerinkinden satarsınız.' },
        { title: 'Paylaşımı şekillendir', desc: 'Bir kanalın ücreti ek ödeme (ücretin üstüne) veya gelir paylaşımı (satıcının marjından) olabilir.' },
      ],
    },
    software: {
      lead: 'Satış kanallarının, sahipleri ve mutabakat biçimiyle dizini.',
      points: [
        { title: 'Oluştur ve yapılandır', desc: 'Bir kanal kaydedin, sahibini (acente veya şirket) ve varsayılan gelir payını / biçimini ayarlayın.' },
        { title: 'Partnerlere ver', desc: 'Bir partner acentenin satabilmesi için bir kanalı Kanal erişimi yoluyla dışa paylaşın.' },
        { title: 'Fiyatlandırmayı besler', desc: 'Markup ve Kurallar’daki Distribution kuralları belirli bir kanalı veya hepsini hedefler.' },
      ],
    },
    related: ['channel-access', 'companies', 'partner-access', 'markup'],
  },

  'channel-access': {
    title: 'Kanal erişimi',
    tag: 'Dağıtım verme',
    tagline: 'Bir partner acentenin satış kanalınızdan satmasına izin vermek.',
    business: {
      lead: 'Kanal erişimi, bir satış kanalının başka bir acenteye ödünç verilme şeklidir. Sahip, bir partnere kanalından satma hakkını verir — genellikle bir gelir payı karşılığında — varlığı devretmeden dağıtımı genişletir. Bu, Distribution fiyatlandırma katmanının arkasındaki ayrıntılı vermedir.',
      points: [
        { title: 'Erişim, bir gelir payı karşılığında', desc: 'Alan taraf kanaldan satar; sahip ondan akan brütün bir payını tutar.' },
        { title: 'İki yönlü onay', desc: 'Bir verme sunulur ve kabul edilir — her iki taraf da anlaşana kadar hiçbir şey paylaşılmaz — ve dilediği zaman geri alınabilir.' },
        { title: 'Distribution kurallarını yönlendirir', desc: 'Vermenin gelir payı eski geri düşüş değeridir; Markup ve Kurallar’daki açık Distribution kuralları onu geçersiz kılar.' },
      ],
    },
    software: {
      lead: 'Kanal vermelerinin defteri — verilen ve alınan.',
      points: [
        { title: 'Ver ve kapsamla', desc: 'Bir partnere bir gelir payı, biçim ve isteğe bağlı geçerlilik penceresiyle bir kanal sunun.' },
        { title: 'Kabul et / reddet', desc: 'Alan taraf erişimi etkinleştirmek için kabul eder veya reddeder.' },
        { title: 'Geri al', desc: 'Bir ilişki bittiğinde erişimi sonlandırın; uçuştaki rezervasyonlar yürürlükteki koşullar üzerinden mutabakata varır.' },
      ],
    },
    related: ['sale-channels', 'partner-access', 'markup', 'companies'],
  },

  'sign-access': {
    title: 'SIGN erişimi',
    tag: 'Wholesale verme',
    tagline: 'Bir partner acentenin SIGN’ınız altında bilet kesmesine izin vermek.',
    business: {
      lead: 'SIGN erişimi, bir biletleme kimlik bilgisini (bir SIGN) başka bir acenteye ödünç verir, böylece kimlik bilgilerine sahip olmadığı bir tedarikçiyi biletleyebilir. SIGN sahibi erişimi verir, o alan tarafa doğru bir markup belirler ve geri alabilir — bu, Wholesale fiyatlandırma katmanının arkasındaki vermedir.',
      points: [
        { title: 'Ödünç kimlik bilgileriyle bilet kes', desc: 'Alan taraf, kendi BSP/IATA kimlik bilgisini kaydetmeden sahibin SIGN’ı altında bilet keser.' },
        { title: 'Alan tarafa doğru markup', desc: 'Sahip verme başına bir wholesale markup belirler — SIGN’ı ödünç vermenin marjı.' },
        { title: 'İki yönlü onay', desc: 'Bir verme sunulur ve kabul edilir ve geri alınabilir; paylaşmak bir izindir, devir değil.' },
      ],
    },
    software: {
      lead: 'SIGN vermelerinin defteri — verilen ve alınan.',
      points: [
        { title: 'Ver ve markup belirle', desc: 'Bir partnere isteğe bağlı bir markup geçersiz kılması ve geçerlilik penceresiyle bir SIGN sunun.' },
        { title: 'Kabul et / reddet', desc: 'Alan taraf SIGN’da bilet kesmeye başlamak için kabul eder veya reddeder.' },
        { title: 'Wholesale kurallarını besler', desc: 'Verme markup’ı eski geri düşüş değeridir; Markup ve Kurallar’daki açık Wholesale kuralları (AGENCY / SIGN kapsamı) onu geçersiz kılar.' },
      ],
    },
    related: ['signs', 'partner-access', 'markup', 'agencies'],
  },

  signs: {
    title: 'SIGN’lar',
    tag: 'Biletleme kimlik bilgileri',
    tagline: 'Bir acentenin bilet kesmek için kullandığı BSP / IATA / CASS kimlik bilgileri.',
    business: {
      lead: 'Bir SIGN, bir acentenin belirli bir tedarikçiye karşı bilet kesmesini sağlayan kayıtlı kimlik bilgisidir. Wholesale katmanının kalbindeki varlıktır: SIGN sahibi doğrudan bilet kesebilir veya SIGN’ı partnerlere ödünç verip (SIGN erişimi) kestikleri üzerinden markup uygulayabilir.',
      points: [
        { title: 'Bilet kesme hakkı', desc: 'Bir SIGN olmadan — ya da birine ödünç erişim olmadan — bir acente o tedarikçiye karşı satabilir ama bilet kesemez.' },
        { title: 'Tedarikçi başına bir etkin', desc: 'Bir acente tedarikçi başına bir etkin SIGN tutar; yenisiyle değiştirilenler silinmez, emekliye ayrılır.' },
        { title: 'Wholesale varlığı', desc: 'Bir SIGN’ı ödünç vermek ve alan tarafın biletlemesine markup uygulamak Wholesale katmanının işidir.' },
      ],
    },
    software: {
      lead: 'Bir acentenin SIGN’larının, tedarikçisi, kodu, düzenleyeni ve geçerliliğiyle sicili.',
      points: [
        { title: 'Bir SIGN kaydet', desc: 'Tedarikçiyi, SIGN kodunu, düzenleyeni ve BSP hesabını bir geçerlilik penceresiyle kaydedin.' },
        { title: 'Bir acenteye ait', desc: 'SIGN’lar her zaman bir acenteye aittir (şirketler kanallara sahiptir, SIGN’lara değil).' },
        { title: 'SIGN erişimi yoluyla paylaş', desc: 'Bir SIGN’ı SIGN erişiminden bir partnere ödünç verin; ilişki bittiğinde geri alın.' },
      ],
    },
    related: ['sign-access', 'partner-access', 'markup', 'agencies'],
  },

  branches: {
    title: 'Şubeler',
    tag: 'Kuruluş yapısı',
    tagline: 'Bir acentenin, personeli ve rezervasyonları kapsamlamak için kullanılan alt ofisleri.',
    business: {
      lead: 'Şubeler bir acentenin fiziksel veya kuruluşsal alt ofislerini modeller. Daha büyük bir acentenin insanlarını düzenlemesine ve rezervasyonları ile performansı, ayrı acentelere bölünmeden, onları yapan ofise atfetmesine olanak tanır.',
      points: [
        { title: 'Atıf', desc: 'Rezervasyonlar ve gelir şube başına raporlanabilir, böylece hangi ofisin performans gösterdiğini görürsünüz.' },
        { title: 'Personel kapsamlama', desc: 'Kullanıcılar bir şubeye atanır, görünümlerini ve izinlerini kendi ofisleriyle sınırlar.' },
        { title: 'Bir acente, çok ofis', desc: 'Şubeler çok ofisli bir acenteyi tek bir işlem ilişkisi olarak tutar.' },
      ],
    },
    software: {
      lead: 'Bir acentenin şubelerinin dizini.',
      points: [
        { title: 'Oluştur ve düzenle', desc: 'Şubeleri adları, iletişim ve konum ayrıntılarıyla ekleyin.' },
        { title: 'Personel ata', desc: 'Şube, acente altında kullanıcılar ve roller sağlanırken kullanılır.' },
        { title: 'Yönetici vs acente görünümü', desc: 'Bir yönetici herhangi bir acentenin şubelerini yönetir; bir acente kendininkini yönetir.' },
      ],
    },
    related: ['agencies', 'agency-profile'],
  },

  'agency-groups': {
    title: 'Acente grupları',
    tag: 'Segmentasyon',
    tagline: 'Tek bir fiyatlandırma kuralıyla hedefleyebileceğiniz adlandırılmış acente kovaları.',
    business: {
      lead: 'Acente grupları segmentasyon kovalarıdır — “Umre uzmanları”, “Tahran kurumsalları” — bütün bir acente setini tek tek yerine birlikte fiyatlandırmanıza olanak tanır. Fiyatlandırma motorundaki GROUP partner kapsamını güçlendirirler.',
      points: [
        { title: 'Segmente göre fiyatlandır', desc: 'Bir grup, partner kapsamı = Grup olan bir Markup ve Kurallar kuralının hedefidir.' },
        { title: 'Üyelik çoka-çoktur', desc: 'Bir acente birden fazla gruba ait olabilir; bir grup birçok acente tutar.' },
        { title: 'Sahip kapsamlı', desc: 'Bir grup platform genelinde paylaşılır veya bir acenteye aittir ve bir durum yaşam döngüsü izler (asla kalıcı olarak silinmez).' },
      ],
    },
    software: {
      lead: 'Gruplar ve üyelikleri için yönetim yüzeyi.',
      points: [
        { title: 'Oluştur ve düzenle', desc: 'Bir grup tanımlayın ve üye acenteler ekleyin veya çıkarın.' },
        { title: 'Fiyatlandırmada hedefle', desc: 'Grup, kural düzenleyicinin Grup partner-kapsamı seçicisinde görünür.' },
        { title: 'Silme değil, yaşam döngüsü', desc: 'Bir grubu duruma göre emekliye ayırın, böylece onu referans veren mevcut kurallar çözümlenebilir kalır.' },
      ],
    },
    related: ['markup', 'agencies'],
  },
};
